import { Box, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { StandardQRCode } from "../../../shared/components/qrCode/StandardQRCode"
import { LocalizedStrict } from "../../localization/components/AppLocalized"

import ArrowRightIcon from "./assets/arrow-right.svg?react"
import { MENU_DISPLAY_SCRIPT_FONT } from "./menuDisplayData"

// The canvas is rendered at a fixed resolution and scaled by CSS to follow the em-sized stage.
const QR_RENDER_SIZE_PX = 512

const useStyles = makeStyles()((theme) => ({
    root: {
        flex: "1 1 auto",
        minHeight: 0,
        padding: "2.25em 3.5em 2.25em 0",
    },
    textGroup: {
        maxWidth: "16em",
        minWidth: 0,
    },
    text: {
        fontFamily: MENU_DISPLAY_SCRIPT_FONT,
        fontWeight: 700,
        fontSize: "2.25em",
        lineHeight: 1,
        letterSpacing: 0,
        color: theme.palette.tailwind.slate[700],
    },
    arrow: {
        flexShrink: 0,
        width: "2.5em",
        height: "2.5em",
        color: theme.palette.tailwind.slate[700],
    },
    code: {
        flexShrink: 0,
        boxSizing: "border-box",
        width: "10.25em",
        height: "10.25em",
        padding: "1em",
        borderRadius: "1.25em",
        border: `.1875em solid ${theme.palette.tailwind.slate[200]}`,
        backgroundColor: theme.palette.common.white,
        "& canvas": {
            width: "100% !important",
            height: "100% !important",
            display: "block",
        },
    },
}))

type Props = Readonly<{
    menuQrUrl: string
}>

export function MenuDisplayScanQr({ menuQrUrl }: Props) {
    const { classes } = useStyles()

    return (
        <Stack direction="column" justifyContent="flex-end" className={classes.root}>
            <Stack direction="row" alignItems="flex-end" justifyContent="space-between" spacing="1em">
                <Stack direction="row" alignItems="flex-end" spacing=".25em" className={classes.textGroup}>
                    <LocalizedStrict id="public-menu-display-scan-qr-text">
                        <Typography className={classes.text}>Scan for week menu</Typography>
                    </LocalizedStrict>
                    <ArrowRightIcon className={classes.arrow} aria-hidden />
                </Stack>
                <Box className={classes.code}>
                    <StandardQRCode url={menuQrUrl} size={QR_RENDER_SIZE_PX} includeMargin={false} />
                </Box>
            </Stack>
        </Stack>
    )
}
